// extracted by mini-css-extract-plugin
export default {"basicFiltersContainer":"basicFilters_basicFiltersContainer__eIsK2","collapsableComponent":"basicFilters_collapsableComponent__jE0c+"};